var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreHorizontalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 4,
    viewBox: "0 0 22 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3dot-conversation",
    "data-name": "3dot-conversation",
    transform: "translate(-672 -1832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Disable_Horizontal_more",
    transform: "translate(694 1832.332) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.331)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.331 18)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.331 9)",
    fill: "#0d0d0d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontalIcon);
export default __webpack_public_path__ + "static/media/more-horizontal-icon.195ca791db4eb9c5b7dc5923baa893f6.svg";
export { ForwardRef as ReactComponent };